import { Select } from '@shopify/polaris';
import React from 'react';

function CountryPicker({ label, countries = [], value, onChange, readOnly = false } = {}) {
    const countryList = countries.map(({ name, iso_numeric_code }) => ({
        label: name,
        value: `${iso_numeric_code}`,
    }));

    return (
        <Select
            label={label}
            options={countryList}
            value={`${value}`}
            onChange={(value) => onChange(value)}
            disabled={readOnly}
        />
    );
}

export default CountryPicker;
